<template>
  <div class="abnormalOrder">
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="from"
      @Refresh="Refresh"
      @search="search"
   
    >
      <template v-slot:right>
        <el-button
          type="warning"
          :disabled="!tableData.length || disabledExport"
          @click="onHandleExport"
          icon="el-icon-upload2"
          >导出</el-button
        >
      </template>
    </Filtersearch>

    <div class="auto-table-flex">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
        ref="multipleTable"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="index" width="100px" align="center" label="序号">
        </el-table-column>
        <el-table-column
          prop="logistic_business_name"
          align="center"
          label="集配中心"
        >
        </el-table-column>
        <el-table-column prop="order_no" align="center" label="订单编号">
        </el-table-column>
        <el-table-column prop="product_title" align="center" label="商品名称">
        </el-table-column>
        <el-table-column
          prop="supplier_title"
          align="center"
          label="供应商名称"
        >
        </el-table-column>
        <el-table-column prop="buyer_name" align="center" label="采购名称">
        </el-table-column>
        <el-table-column prop="pay_at" align="center" label="支付时间">
        </el-table-column>
        <el-table-column
          prop="abnormal_order_type_name"
          align="center"
          label="类型"
        >
        </el-table-column>
        <el-table-column prop="logistics_name" align="center" label="城市仓">
        </el-table-column>
        <el-table-column prop="member_name" align="center" label="客户名称">
        </el-table-column>
        <el-table-column prop="member_mobile" align="center" label="客户电话">
        </el-table-column>
      </el-table>
    </div>

    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import Filtersearch from "@/components/Filtersearch.vue";
import { abnormalorderlist } from "@/api/export/index.js";
import { downLoadFlowBlob } from "@/utils/tools/base";
import { time } from "echarts";
export default {
  name: "abnormalOrder",
  components: {
    Filtersearch,
  },
  data() {
    return {
      Filtersearchlist: [
        {
          type: "input",
          name: "订单编号",
          clearable: true,
          model: "order_no",
          placeholder: "请输入订单编号",
        },
        {
          type: "datetimerange",
          name: "支付时间",
          clearable: false,
          model: "start",
          startmodel: "start_time",
          endmodel: "end_time",
          startplaceholder: "开始时间",
          endplaceholder: "结束时间",
          fromat: "yyyy-MM-dd HH:mm:ss",
        },
        {
          type: "select",
          name: "集配中心",
          clearable: true,
          filterable: true,
          model: "logistic_business_id",
          placeholder: "请选择集配中心",
          selectoptionname: "businessList",
          label: "name",
          value: "id",
          selectoption: [],
        },
        {
          type: "select",
          name: "类型",
          clearable: true,
          model: "abnormal_order_type",
         
          placeholder: "请选择类型",
          label: "label",
          value: "value",
          selectoption: [
            {
              label: "供应商购买",
              value: "1",
            },
            {
              label: "单发仓",
              value: "2",
            },
          ],
        },
      ],
      //列表新建页面初始参数
      loading: true,

      from: {
        start: [],
        start_time: "",
        end_time: "",
        order_no: "",
        logistic_business_id: "",
        abnormal_order_type: "",
        page: 1,
        pageSize: 10,
      },

      tableData: [],
      currentPage: 1,
      total: 0,
      done: 2, // 已付款状态
      //列表页面不同功能参数

      options: [],
      storelist: [],
      selflist: [],
      logistics_id: "",
      list: [],
      list1: [],
      disabledExport: false, // 导出禁用
      totalObj: {}, // 汇总数据
    };
  },
  computed: {},
  created() {
    
this.timehq();
    this.hqlist();

    this.getBusinessList();
  },
  methods: {
    timehq(){
 // 增加默认逻辑 超过14点 开始结束时间为今天到明天12点 反之 开始结束时间为昨天到今天12点
    let now = new Date();
    const hour = now.getHours();
    let start, end;
    if (hour >= 14) {
      // 今天14:00:00 到 明天14:00:00
      start = new Date(now);
      start.setHours(14, 0, 0, 0);

      end = new Date(now);
      end.setDate(end.getDate() + 1);
      end.setHours(14, 0, 0, 0);
    } else {
      // 昨天14:00:00 到 今天14:00:00
      start = new Date(now);
      start.setDate(start.getDate() - 1);
      start.setHours(14, 0, 0, 0);

      end = new Date(now);
      end.setHours(14, 0, 0, 0);
    }
    this.from.start = [
      this.tool.timestampToTime(start),
      this.tool.timestampToTime(end),
    ];
    this.from.start_time = this.tool.timestampToTime(start);
    this.from.end_time = this.tool.timestampToTime(end);
    },
    // 集配中心列表
    getBusinessList() {
      this.$api.general.businessList().then((res) => {
        this.options = res.data;
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "businessList"
          ) {
            el.selectoption = [{ id: "", name: "全部" }, ...res.data];
          }
        });
      });
    },

    /**
     * 导出数据（下载中心）
     */
    async onHandleExport() {
      let obj = JSON.parse(JSON.stringify(this.from));
      delete obj.page;
      delete obj.pageSize;
      try {
        const res = await abnormalorderlist(obj);
        downLoadFlowBlob(res, res?.filename);
      } catch (error) {
        console.log(error, "postCategoriesListExport");
      }
    },

    search(e) {
      this.from = e;
      this.from.page = 1;
      this.currentPage = 1;

      this.hqlist();
    },

    Refresh() {
        
      Object.assign(this.$data.from, this.$options.data().from);
     
      this.timehq();
      this.hqlist();
    },
    handleSizeChange(val) {
      //   console.log(`每页 ${val} 条`);
      this.from.pageSize = val;

      this.hqlist();
    },
    handleCurrentChange(val) {
      this.from.page = val;
      this.currentPage = val;

      this.hqlist();
    },

    hqlist() {
      this.loading = true;

      this.$api.general.abnormalorderlist(this.from).then((res) => {
        console.log(res, "获取数据");
        this.tableData = res.data.data;
        this.total = res.data.total;

        this.loading = false;
      });
    },
  },
};
</script>
<style lang="scss">
.abnormalOrder {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  //   background: #ffffff;
  padding: 10px;

  .checked-box {
    padding: 13px 15px;
  }

  .order-wrapper {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    background: #ffffff;
    padding: 10px 15px;

    .inputs {
      margin-right: 10px;
      margin-bottom: 10px;
    }

    .multiple-select {
      width: 250px;
    }
    .multiple-select-long {
      width: 320px;
      .el-select__input {
        height: auto;
      }
    }
  }

  .top {
    display: flex;
    align-items: center;
    .span {
      width: 100px;
    }
    &:nth-of-type(1),
    &:nth-of-type(4),
    &:nth-of-type(5) {
      margin-left: 15px;
    }
  }
  .mid {
    height: 36px;
    line-height: 36px;
  }
  .title {
    background: #ffffff;
    padding-top: 10px;
    padding-left: 15px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    .inputs {
      display: flex;
      align-items: center;
    }
    .seach {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;

      .multiple-select {
        width: 250px;
      }
    }

    .bjsearch {
      background: #333333;
      border-color: #333333;
    }
  }

  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }

  .fy {
    // background-color: #000;
    box-sizing: border-box;
    padding: 10px 20px;
  }

  .contents {
    padding-left: 55px;
    padding-right: 55px;
    padding-top: 23px;

    box-sizing: border-box;

    .titlname {
      font-size: 17px;
      color: #21c2ac;
      margin-bottom: 25px;
    }

    .imgs {
      display: flex;

      .imglist {
        width: 165px;
        height: 123px;
        border: 1px dashed #a4adc5;
        padding: 14px 8px;
        text-align: center;
        border-radius: 7px;
        box-sizing: border-box;
        margin-right: 16px;

        .div {
          margin-top: 20px;
          padding-bottom: 20px;
        }

        // img{
        //     width: 100%;
        //     height: 100%;
        // }
      }
    }

    .disply {
      display: flex;
      margin-bottom: 22px;
    }

    .mr {
      margin-right: 31px;
    }

    .iteminput {
      display: flex;
      align-items: center;

      .wen {
        width: 77px;
        margin-right: 24px;
        color: #000;
        font-size: 14px;
        text-align: right;
      }

      .el-input {
        width: 302px;
      }
    }
  }

  .colors {
    color: #fa884c;
  }

  .times {
    margin-right: 8px;
  }

  // .el-picker-panel {
  //   left: 1245px !important;
  // }
}
</style>
